import React from "react";
import { useState, useRef, useEffect } from 'react';
import { Nav, NavLink, NavMenu }
	from "./NavbarElements";
import './navbar2.css';
import UserModal from '../pages/UserModal';
import { useLocation } from 'react-router-dom';
import { PiPhoneCallBold } from "react-icons/pi";
import Collapsible from './Collapsible2';
	

const Navbar = () => {
	const [colorChange, setColorchange] = useState(false);
	//const [showDropdown, setShowDropdown] = useState(false);
	const location = useLocation();
	const [showMenu, setShowMenu] = useState(false);
	const [showDropdown, setShowDropdown] = useState(false);
	const [isVisibleLinks, setIsVisibleLinks] = useState(false);
	const [isVisibleCenter, setIsVisibleCenter] = useState(false);
    const linksRef = useRef(null);
    const centerRef = useRef(null);
	const [isToggled, setIsToggled] = useState(false); 
	const [showServicesCollapsible, setShowServicesCollapsible] = useState(false);
	const [linkVisibility, setLinkVisibility] = useState([true, true, true, true]); // Track visibility of each link 
	const [isModalOpen, setIsModalOpen] = useState(false);

	const openModal = () => setIsModalOpen(true);
	const closeModal = () => setIsModalOpen(false);
	console.log(isModalOpen);



	const toggleServicesCollapsible = () => {
        setShowServicesCollapsible(!showServicesCollapsible);
    };


	function getCurrentPage() {
		const pathArray = location.pathname.split('/').filter(Boolean);
		const currentPage = pathArray.length > 0 ? pathArray[pathArray.length - 1] : 'default';
		
		return currentPage;
	  }
	
	  const getLinkStyle = (page) => {
		const isScrolled = colorChange;
		const currentPage = getCurrentPage();
		const viewportWidth = window.innerWidth;

		// Check if the link is active
		const isActive = page === currentPage || (page === 'home' && currentPage === 'default');

			if (isActive) {
    			return null; // No custom styles for active link
  		}

		  
			if (viewportWidth <= 1080) {
			return {
			  color: 'white', // Set color to white for smaller viewports
			};
		  }

		switch (currentPage) {
			case 'home':
			return {
			  color: isScrolled ? 'black' : 'white',
			 
			
			};
		  case 'about':
			return {
			  color: isScrolled ? 'white' : 'white',
			  
			};
		case 'services':
			return {
			  color: isScrolled ? 'white' : 'white',
			};
		case 'contact':
			return {
			  color: isScrolled ? 'white' : 'white',
			};

		  default:
			return {
			  color: isScrolled ? 'white' : 'white',
			  
			};
			
		}
	  };

	useEffect(() => {
		setColorchange(window.scrollY >= 10);
		
	  }, []);
	// eslint-disable-next-line
	  const changeNavbarColor = () => {
		setColorchange(window.scrollY >= 10);
		
		};

		//const handleScroll = () => {
			
			/*if (linksRef.current) {
			  const linksRect = linksRef.current.getBoundingClientRect();
			  const triggerOffsetLinks = 100;
			  const triggerPointLinks = window.innerHeight - triggerOffsetLinks;
			  const isAboveTriggerPointLinks = linksRect.top < triggerPointLinks;
			  setIsVisibleLinks(isAboveTriggerPointLinks);
			}*/
		
			//if (centerRef.current) {
			  //const centerRect = centerRef.current.getBoundingClientRect();
			  /*const triggerOffsetCenter = 10; // Adjust this value for different trigger points
			  const triggerPointCenter = window.innerHeight - triggerOffsetCenter;
			  const isAboveTriggerPointCenter = centerRect.top < triggerPointCenter;*/
			  //setIsVisibleCenter(window.scrollY >= 10);
			//}
		  //};

		  useEffect(() => {
			setIsVisibleCenter(window.scrollY >= 10);
		  }, []);
		// eslint-disable-next-line
		  const handleScroll = () => {
			setIsVisibleCenter(window.scrollY >= 10);
		};
		
		  useEffect(() => {
			window.addEventListener('scroll', handleScroll);
			handleScroll(); // Check visibility on initial render
			return () => {
			  window.removeEventListener('scroll', handleScroll);
			};
		  }, []);
	
	  useEffect(() => {
		window.addEventListener('scroll', changeNavbarColor);
	
		// Cleanup event listener on component unmount
		return () => {
		  window.removeEventListener('scroll', changeNavbarColor);
		};
	  }, [changeNavbarColor]);

	  

	  // Close the dropdown menu when the user navigates to a new page
	  useEffect(() => {
        setShowMenu(false);
  	  }, [location]);

	  const toggleMenu = () => {
		setShowMenu(!showMenu);
		setIsToggled(!isToggled);
	
		if (isToggled) {
	
			setShowMenu(false); // Close menu if links are opened
	
		}

	  };


	const toggleLinks = () => {
		
		setIsToggled(!isToggled);
	
		if (isToggled) {
	
			setShowMenu(false); // Close menu if links are opened
	
		}
	
	};

	  const getBarColor = () => {
		const isScrolled = colorChange;
		const currentPage = getCurrentPage();
		
		switch (currentPage) {
		  case 'home':
			return isScrolled ? 'white' : 'white';
		  case 'about':
			return isScrolled ? 'white' : 'white';
		  case 'services':
			return isScrolled ? 'white' : 'white';
		  case 'contact':
			return isScrolled ? 'white' : 'white';		
		  default:
			return isScrolled ? 'white' : 'white';
		}
	  };
	
	  const barStyle = {
		backgroundColor: getBarColor(),
	  };

	  useEffect(() => {
		// Scroll to the top when the component mounts
		window.scrollTo(0, 0);
	  }, []); // Empty dependency array ensures this effect runs only once
	
	
	useEffect(() => {
		const hash = window.location.hash.substring(1);
		if (hash) {
		  const targetElement = document.getElementById(hash);
		  if (targetElement) {
			targetElement.scrollIntoView({ behavior: 'smooth' });
		  }
		}
	  }, []);

	  const handleDropdownToggle = () => {
		setShowDropdown(!showDropdown);
	  };
	  

	return (
		<>
			<Nav className={`${isVisibleCenter && !isToggled  ? 'visible' : ''} ${colorChange ? 'navbar colorChange' : 'navbar'} ${showMenu ? 'active' : ''}`}
					style={{transitionDelay: '.9s'}}>
				<NavMenu className={`${isToggled ? 'navbar-hidden' : 'navbar-visible'} ${showMenu ? 'active' : ''}`} >
					<NavLink to="/" id='logo_div2' className={`${isToggled ? 'toggled' : ''}`} >
          				<div id="logo_div" className={`${isToggled ? 'toggled' : ''}`} onClick={() => setIsToggled(false)}></div>
					</NavLink>
					
                    <NavLink  to="/" activeStyle id='homelink' activeClassName="active" className={`center_indexdiv ${isVisibleCenter && !isToggled  ? 'visible' : ''} ${isToggled ? 'toggled' : ''}`} style={{transitionDelay: '.3s', getLinkStyle:'home'}} onClick={() => setIsToggled(false)}>
						Home
					</NavLink>
					<NavLink to="/about" activeStyle id='aboutlink' activeClassName="active" className={`center_indexdiv ${isVisibleCenter && !isToggled  ? 'visible' : ''} ${isToggled ? 'toggled' : ''}`} style={{transitionDelay: '.4s',getLinkStyle:'about'}} onClick={() => setIsToggled(false)}>
						About Us
					</NavLink>
					<NavLink
                        
                        activeStyle
                        activeClassName="active"
                        style={{ transitionDelay: '0.4s', ...getLinkStyle('') }}
                        className={`center_indexdiv services ${isVisibleCenter && !isToggled ? 'visible' : ''} ${isToggled ? 'toggled' : ''}`}
                        onClick={(e) => {
							if (showMenu) {
								e.preventDefault(); // Prevent default navigation
							}
							if (isToggled) {
								toggleServicesCollapsible(e);
							}
							
						}}// Click to toggle on mobile, null on desktop
                        onMouseEnter={isToggled ? null : handleDropdownToggle} // Hover on desktop
                        onMouseLeave={isToggled ? null : handleDropdownToggle} // Hover on desktop
                    >
                        Services
						{(showMenu || isToggled) ? (
                            <Collapsible isOpen={showServicesCollapsible} onToggle={toggleServicesCollapsible}>
                                <NavLink
                                    to="/tree_trimming"
                                    activeStyle
                                    activeClassName="active"
									className="dropdown_navlinks"
                                    style={{ ...getLinkStyle('services') }}
                                    onClick={() => {
                                        window.scrollTo(0, 0);
                                        setIsToggled(false); // Add this line!
                                    }}
                                >
                                    Tree Trimming
                                </NavLink>
                                <NavLink
                                    to="/tree_removal"
                                    activeStyle
                                    activeClassName="active"
									className="dropdown_navlinks"
                                    style={{ ...getLinkStyle('services') }}
                                    onClick={() => {
                                        window.scrollTo(0, 0);
                                        setIsToggled(false); // Add this line!
                                    }}
                                >
                                    Tree removal
                                </NavLink>
                                <NavLink
                                    to="/stump_removal"
                                    activeStyle
                                    activeClassName="active"
									className="dropdown_navlinks"
                                    style={{ ...getLinkStyle('services') }}
                                    onClick={() => {
                                        window.scrollTo(0, 0);
                                        setIsToggled(false); // Add this line!
                                    }}
                                >
                                    Stump Removal
                                </NavLink>
                                <NavLink
                                    to="/debris_hauling"
                                    activeStyle
                                    activeClassName="active"
									className="dropdown_navlinks"
                                    style={{ ...getLinkStyle('services') }}
                                    onClick={() => {
										window.scrollTo(0, 0);
										setIsToggled(false);
									}}
                                >
                                    Debris Hauling
                                </NavLink>
                            </Collapsible>
                        ) : (
                            showDropdown && (
                                <div className={`dropdown-content ${isToggled ? 'toggled' : ''}`} onClick={() => setIsToggled(false)}>
                                    <NavLink
                                        to="/tree_trimming"
                                        activeStyle
                                        activeClassName="active"
                                        style={{ ...getLinkStyle('services') }}
                                        onClick={() => window.scrollTo(0, 0)}
                                    >
                                        Tree Trimming
                                    </NavLink>
                                    <NavLink
                                        to="/tree_removal"
                                        activeStyle
                                        activeClassName="active"
                                        style={{ ...getLinkStyle('services') }}
                                        onClick={() => window.scrollTo(0, 0)}
                                    >
                                        Tree removal
                                    </NavLink>
                                    <NavLink
                                        to="/stump_removal"
                                        activeStyle
                                        activeClassName="active"
                                        style={{ ...getLinkStyle('services') }}
                                        onClick={() => window.scrollTo(0, 0)}
                                    >
                                        Stump Removal
                                    </NavLink>
                                    <NavLink
                                        to="/debris_hauling"
                                        activeStyle
                                        activeClassName="active"
                                        style={{ ...getLinkStyle('services') }}
                                        onClick={() => window.scrollTo(0, 0)}
                                    >
                                        Debris Hauling
                                    </NavLink>
                                </div>
                            )
                        )}
                    </NavLink>
					
					  <NavLink to="/reviews" activeStyle id='reviewslink' activeClassName="active" className={`center_indexdiv ${isVisibleCenter && !isToggled  ? 'visible' : ''} ${isToggled ? 'toggled' : ''}`} style={{transitionDelay: '.5s', getLinkStyle:'contact'}} onClick={() => setIsToggled(false)}>
					   Our reviews
					</NavLink>
					<NavLink to="/contact" activeStyle id='contactlink' activeClassName="active" className={`center_indexdiv ${isVisibleCenter && !isToggled  ? 'visible' : ''} ${isToggled ? 'toggled' : ''}`} style={{transitionDelay: '.6s', getLinkStyle:'contact'}} onClick={() => setIsToggled(false)}>
						Contact Us
					</NavLink>
					
					
					<NavLink  activeStyle id='emergency_phone' activeClassName="active" className={`center_indexdiv ${isVisibleCenter && !isToggled  ? 'visible' : ''} ${isToggled ? 'toggled' : ''}`} style={{transitionDelay: '.8s',getLinkStyle:'sign-up'}} onClick={() => setIsToggled(false)}>
					    <div className='emergency_phone_app' onClick={() => window.location.href = 'tel:941-879-8853'}>
							<div className='circle_icon_emergency_phone_app'><PiPhoneCallBold /></div>
							<span>24/7 Emergency#</span>
						</div>
						
					</NavLink>
					
				</NavMenu>
			</Nav>
			<div id="fixed-elements" className={`${isToggled ? 'toggled' : ''}`}>
			<div
  						to="#"
						id='appointment_modal_button' 
  						onClick={(e) => {
    						e.preventDefault(); // Prevent the default link action
    						openModal();
  						}}
  					className={`center_indexdiv2 ${isVisibleCenter && !isToggled ? 'visible' : ''} ${isToggled ? 'toggled' : ''}`}
  					style={{ transitionDelay: '.8s', getLinkStyle: 'sign-up' }}
						>
  						Request An Appointment
					</div>


					<NavLink  activeStyle  id='menutoggle' activeClassName="active" className={`center_indexdiv3 ${isVisibleCenter && !isToggled  ? 'visible' : ''} ${isToggled ? 'active' : ''}`} style={{transitionDelay: '.7s'}} onClick={toggleLinks}>
						Menu 
					</NavLink>
			</div>

			<div className="hamburger"  onClick={toggleMenu} >
    					<span style={barStyle}  className="bar"></span>
    					<span style={barStyle}  className="bar"></span>
    					<span style={barStyle}  className="bar"></span>
			</div>
			{isModalOpen && <UserModal onClose={closeModal} />}
			<UserModal isOpen={isModalOpen} onClose={closeModal} />

		</>
	);
};

export default Navbar;


/*<NavLink to="/about" activeStyle id='aboutlink' activeClassName="active" className={`center_indexdiv ${isVisibleCenter && !isToggled  ? 'visible' : ''} ${isToggled ? 'toggled' : ''}`} style={{transitionDelay: '.4s',getLinkStyle:'about'}} onClick={() => setIsToggled(false)}>
						Services
					</NavLink>



<NavLink  activeStyle activeClassName="active" style={{ transitionDelay: '.4s', ...getLinkStyle('')}} className={`center_indexdiv services ${isVisibleCenter && !isToggled  ? 'visible' : ''} ${isToggled ? 'toggled' : ''}`} onClick={() => setIsToggled(false)}
            				onMouseEnter={handleDropdownToggle}
            				onMouseLeave={handleDropdownToggle}
          					>Services
            				{showDropdown && (
              				<div className={`dropdown-content ${isToggled ? 'toggled' : ''}`} onClick={() => setIsToggled(false)}>
                			<NavLink to="/tree_trimming" activeStyle activeClassName="active" style={{ ...getLinkStyle('services')}}  onClick={() => window.scrollTo(0, 0)}>
									Tree Trimming
                			</NavLink>
                			<NavLink to="/tree_removal" activeStyle activeClassName="active" style={{ ...getLinkStyle('services')}}  onClick={() => window.scrollTo(0, 0)}>
									Tree removal
                			</NavLink>
							<NavLink to="/stump_removal" activeStyle activeClassName="active" style={{ ...getLinkStyle('services')}}  onClick={() => window.scrollTo(0, 0)}>
									Stump Removal
                			</NavLink>
							<NavLink to="/debris_hauling" activeStyle activeClassName="active" style={{ ...getLinkStyle('services')}}  onClick={() => window.scrollTo(0, 0)}>
									Debris Hauling
                			</NavLink>
              				</div>
            				)}
          			</NavLink>


					<NavLink
                        
                        activeStyle
                        activeClassName="active"
                        style={{ transitionDelay: '0.4s', ...getLinkStyle('') }}
                        className={`center_indexdiv services ${isVisibleCenter && !isToggled ? 'visible' : ''} ${isToggled ? 'toggled' : ''}`}
                        onClick={isToggled ? toggleServicesCollapsible : null} // Click to toggle on mobile, null on desktop
                        onMouseEnter={isToggled ? null : handleDropdownToggle} // Hover on desktop
                        onMouseLeave={isToggled ? null : handleDropdownToggle} // Hover on desktop
                    >
                        Services
                        {isToggled ? (
                            <Collapsible isOpen={showServicesCollapsible} onToggle={toggleServicesCollapsible}>
                                <NavLink
                                    to="/tree_trimming"
                                    activeStyle
                                    activeClassName="active"
                                    style={{ ...getLinkStyle('services') }}
                                    onClick={() => {
                                        window.scrollTo(0, 0);
                                        setIsToggled(false); // Add this line!
                                    }}
                                >
                                    Tree Trimming
                                </NavLink>
                                <NavLink
                                    to="/tree_removal"
                                    activeStyle
                                    activeClassName="active"
                                    style={{ ...getLinkStyle('services') }}
                                    onClick={() => {
                                        window.scrollTo(0, 0);
                                        setIsToggled(false); // Add this line!
                                    }}
                                >
                                    Tree removal
                                </NavLink>
                                <NavLink
                                    to="/stump_removal"
                                    activeStyle
                                    activeClassName="active"
                                    style={{ ...getLinkStyle('services') }}
                                    onClick={() => {
                                        window.scrollTo(0, 0);
                                        setIsToggled(false); // Add this line!
                                    }}
                                >
                                    Stump Removal
                                </NavLink>
                                <NavLink
                                    to="/debris_hauling"
                                    activeStyle
                                    activeClassName="active"
                                    style={{ ...getLinkStyle('services') }}
                                    onClick={() => window.scrollTo(0, 0)}
                                >
                                    Debris Hauling
                                </NavLink>
                            </Collapsible>
                        ) : (
                            showDropdown && (
                                <div className={`dropdown-content ${isToggled ? 'toggled' : ''}`} onClick={() => setIsToggled(false)}>
                                    <NavLink
                                        to="/tree_trimming"
                                        activeStyle
                                        activeClassName="active"
                                        style={{ ...getLinkStyle('services') }}
                                        onClick={() => window.scrollTo(0, 0)}
                                    >
                                        Tree Trimming
                                    </NavLink>
                                    <NavLink
                                        to="/tree_removal"
                                        activeStyle
                                        activeClassName="active"
                                        style={{ ...getLinkStyle('services') }}
                                        onClick={() => window.scrollTo(0, 0)}
                                    >
                                        Tree removal
                                    </NavLink>
                                    <NavLink
                                        to="/stump_removal"
                                        activeStyle
                                        activeClassName="active"
                                        style={{ ...getLinkStyle('services') }}
                                        onClick={() => window.scrollTo(0, 0)}
                                    >
                                        Stump Removal
                                    </NavLink>
                                    <NavLink
                                        to="/debris_hauling"
                                        activeStyle
                                        activeClassName="active"
                                        style={{ ...getLinkStyle('services') }}
                                        onClick={() => window.scrollTo(0, 0)}
                                    >
                                        Debris Hauling
                                    </NavLink>
                                </div>
                            )
                        )}
                    </NavLink>



					<NavLink to="/admin" activeStyle id='log-in_link' activeClassName="active" className={`center_indexdiv ${isVisibleCenter && !isToggled  ? 'visible' : ''} ${isToggled ? 'toggled' : ''}`} style={{transitionDelay: '.7s',getLinkStyle:'sign-up'}} onClick={() => setIsToggled(false)}>
					    Admin
					</NavLink>
*/					

